<template>
    <div>
        <b-row>
            <b-col md="8">
                <dl class="info-grid mb-0">
                    <dt>No. Request</dt>
                    <dd>{{ data.no_request }}</dd>
                    <dt>No. Box</dt>
                    <dd>{{ data.no_box }}</dd>
                    <dt>Alamat</dt>
                    <dd>{{ data.address || "-" }}</dd>
                    <dt>No. Resi</dt>
                    <dd>{{ data.no_resi || "-" }}</dd>
                    <dt>Kurir</dt>
                    <dd>{{ courierLabel(data.courier) }}</dd>
                    <dt>Status</dt>
                    <dd>
                        <b-badge :variant="getBoxStatusBadge(data.status)[0]">
                            {{ getBoxStatusBadge(data.status)[1] }}
                        </b-badge>
                    </dd>
                </dl>
            </b-col>
            <b-col
                md="4"
                class="mt-3 mt-md-0 d-flex justify-content-md-end align-items-start"
            >
                <div class="text-md-right">
                    <div class="field-label">Foto Packing</div>
                    <a
                        v-if="data.photo_packing"
                        :href="data.photo_packing"
                        target="_blank"
                        class="photo-thumb-wrap"
                    >
                        <img :src="data.photo_packing" alt="Foto Packing" />
                    </a>
                    <strong v-else>-</strong>
                </div>
                <div class="text-md-right ml-3">
                    <div class="field-label">Video Packing</div>
                    <a
                        v-if="data.video_packing"
                        :href="data.video_packing"
                        target="_blank"
                        class="video-thumb-wrap"
                    >
                        <video
                            :src="data.video_packing"
                            preload="metadata"
                        ></video>
                        <span class="play-badge"><i class="fa fa-play"></i></span>
                    </a>
                    <strong v-else>-</strong>
                </div>
            </b-col>
        </b-row>

        <b-row class="mb-4 mt-2">
            <b-col md="12" class="d-flex align-items-end justify-content-end">
                <b-form-group class="mb-0">
                    <b-button
                        variant="info"
                        class="mr-2 text-white"
                        @click="$bvModal.show('m-print-qr')"
                    >
                        <i class="fa fa-qrcode" /> Cetak QR Box
                    </b-button>
                    <b-button
                        variant="primary"
                        class="mr-2"
                        @click="$bvModal.show('m-print-invoice')"
                    >
                        <i class="fa fa-print" /> Cetak Faktur
                    </b-button>
                    <b-button
                        v-if="data.status == BoxStatus.CREATED"
                        variant="danger"
                        class="mr-2"
                        @click="confirmDeleteBox()"
                    >
                        <i class="fa fa-trash" /> Hapus Box
                    </b-button>
                    <b-button
                        v-if="data.status == BoxStatus.CREATED"
                        variant="success"
                        @click="confirmSendShipment()"
                    >
                        <i class="fa fa-paper-plane" /> Kirim ke PEI
                    </b-button>
                </b-form-group>
            </b-col>
        </b-row>

        <b-table
            bordered
            hover
            show-empty
            no-local-sorting
            :busy="isBusy"
            :items="items"
            :fields="fields"
            responsive
        >
            <template v-slot:empty>
                Tidak ada item pengiriman.
            </template>
            <template v-slot:cell(brand)="row">
                {{ row.item.brand || "-" }}
            </template>
            <template v-slot:cell(type)="row">
                {{ row.item.type || "-" }}
            </template>
            <template v-slot:cell(dry_weight)="row">
                {{ row.item.dry_weight ? row.item.dry_weight : "0" }}
                gr
            </template>
            <template v-slot:cell(weight_reduction)="row">
                {{
                    row.item.weight_reduction ? row.item.weight_reduction : "0"
                }}
                gr
            </template>
            <template v-slot:cell(purity)="row">
                {{ row.item.purity || "-" }}
            </template>
            <template v-slot:cell(status)="row">
                <b-badge :variant="getItemStatusBadge(row.item.status)[0]">
                    {{ getItemStatusBadge(row.item.status)[1] }}
                </b-badge>
            </template>
            <template v-slot:cell(action)="row">
                <div class="text-nowrap">
                    <b-button
                        size="sm"
                        variant="primary"
                        class="mr-1"
                        v-b-tooltip.hover.top
                        title="Lihat Log Aktivitas"
                        @click="$emit('log', row.item.pei_request_item_id)"
                    >
                        <i class="fa fa-fw fa-history" />
                    </b-button>
                    <b-button
                        v-if="data.status === BoxStatus.CREATED"
                        size="sm"
                        variant="outline-danger"
                        v-b-tooltip.hover.top
                        title="Keluarkan dari Box"
                        @click="confirmCancelItem(row.item)"
                    >
                        <i class="fa fa-fw fa-times" />
                    </b-button>
                </div>
            </template>
        </b-table>
        <PageSizer
            :totalRows="totalRows"
            :page="currentPage"
            :options="options"
            @limit-change="onLimitChange"
            @page-change="onPageChange"
        />

        <b-modal
            id="m-confirm-send-shipment"
            title="Informasi Pengiriman"
            centered
            no-close-on-backdrop
            hide-footer
        >
            <b-alert show variant="info">
                <i class="fa fa-info-circle mr-1" />
                Pastikan QR Box & Faktur sudah dicetak dan ditempel di box
                sebelum dikirim.
            </b-alert>
            <div>
                <label> Kurir <span style="color: red;">*</span> </label>
                <b-form-group>
                    <b-form-select
                        v-model="input.courier"
                        :options="courierOptions"
                    />
                    <small v-if="isPickup" class="form-text text-muted"
                        >Kurir Pickup tidak perlu No. Resi.</small
                    >
                </b-form-group>
            </div>
            <div v-if="!isPickup">
                <label> No. Resi <span style="color: red;">*</span> </label>
                <b-form-group>
                    <b-form-input
                        v-model="input.no_resi"
                        placeholder="Masukkan nomor resi..."
                        maxlength="50"
                    />
                </b-form-group>
            </div>
            <b-row>
                <b-col cols="6">
                    <label>
                        Foto Packing <span style="color: red;">*</span>
                        <small class="text-muted">(JPG/PNG, maks 10MB)</small>
                    </label>
                    <b-form-group>
                        <b-form-file
                            v-if="!photo.path"
                            accept="image/jpeg, image/png"
                            placeholder="Pilih foto..."
                            browse-text="Browse"
                            @input="onMediaPicked('photo', $event)"
                        />
                        <div v-else class="d-inline-flex flex-column">
                            <a
                                :href="photo.previewUrl"
                                target="_blank"
                                class="photo-thumb-wrap"
                            >
                                <img :src="photo.previewUrl" alt="Foto Packing" />
                            </a>
                            <b-button
                                variant="outline-danger"
                                size="sm"
                                class="mt-2"
                                @click="clearMedia('photo')"
                            >
                                <i class="fa fa-trash mr-1"></i> Hapus
                            </b-button>
                        </div>
                    </b-form-group>
                </b-col>
                <b-col cols="6">
                    <label>
                        Video Packing <span style="color: red;">*</span>
                        <small class="text-muted">(MP4/MOV, maks 400MB)</small>
                    </label>
                    <b-form-group>
                        <b-form-file
                            v-if="!video.path"
                            accept="video/mp4, video/quicktime"
                            placeholder="Pilih video..."
                            browse-text="Browse"
                            @input="onMediaPicked('video', $event)"
                        />
                        <div v-else class="d-inline-flex flex-column">
                            <a
                                :href="video.previewUrl"
                                target="_blank"
                                class="video-thumb-wrap"
                            >
                                <video
                                    :src="video.previewUrl"
                                    preload="metadata"
                                ></video>
                                <span class="play-badge"
                                    ><i class="fa fa-play"></i
                                ></span>
                            </a>
                            <b-button
                                variant="outline-danger"
                                size="sm"
                                class="mt-2"
                                @click="clearMedia('video')"
                            >
                                <i class="fa fa-trash mr-1"></i> Hapus
                            </b-button>
                        </div>
                    </b-form-group>
                </b-col>
            </b-row>
            <div class="text-right mt-3">
                <b-button
                    variant="success"
                    @click="executeSendShipment()"
                    :disabled="isSubmitting"
                >
                    <template v-if="!isSubmitting">
                        <i class="fa fa-paper-plane" />
                        Kirim
                    </template>
                    <template v-else>
                        <b-spinner small />
                        Kirim
                    </template>
                </b-button>
            </div>

            <loading-overlay
                :fotoStartTime="uploadTimeStamp.startPresignedUrl"
                :fotoEndTime="uploadTimeStamp.endPresignedUrl"
                :uploadStartTime="uploadTimeStamp.startUploadToS3"
                :uploadEndTime="uploadTimeStamp.endUploadToS3"
                :penyimpananStartTime="uploadTimeStamp.startSaveFile"
                :penyimpananEndTime="uploadTimeStamp.endSaveFile"
                :show="isShowLoadingOverlay"
            />
        </b-modal>

        <b-modal
            id="m-print-invoice"
            title="Cetak Faktur"
            no-close-on-backdrop
            no-close-on-esc
            hide-footer
            hide-header-close
        >
            Silakan cetak faktur di bawah ini. Pastikan faktur tercetak dengan
            baik sebelum melanjutkan.
            <br /><br />
            <iframe
                id="invoice-iframe"
                :src="$BASE_PRINT_FILE_PATH + getInvoiceLink()"
                height="300px"
                width="100%"
            />
            <div id="print-invoice-actions" class="mt-3">
                <b-row>
                    <b-col md="6">
                        <b-button
                            id="toggle-invoice-size"
                            variant="dark"
                            :disabled="invoiceSizeCooldown"
                            @click="toggleInvoiceSize"
                        >
                            Print {{ invoiceSize == "A5" ? "A4" : "A5" }}
                        </b-button>
                    </b-col>
                    <b-col md="6" class="text-right">
                        <b-button
                            id="close-print-invoice"
                            variant="primary"
                            @click="$bvModal.hide('m-print-invoice')"
                        >
                            Tutup
                        </b-button>
                    </b-col>
                </b-row>
            </div>
        </b-modal>

        <b-modal id="m-print-qr" title="Cetak QR Box" hide-footer>
            Tempelkan QR ini pada box <strong>{{ data.no_box }}</strong> untuk
            dipindai oleh PEI.
            <br /><br />
            <iframe
                id="qr-iframe"
                :src="$BASE_PRINT_FILE_PATH + qrLink"
                height="380px"
                width="100%"
            />
            <div class="mt-3 text-right">
                <b-button
                    variant="primary"
                    @click="$bvModal.hide('m-print-qr')"
                >
                    Tutup
                </b-button>
            </div>
        </b-modal>
    </div>
</template>

<script>
import LoadingOverlay from "../barang-masuk/LoadingOverlay.vue";
import { PICKUP, COURIER_OPTIONS, courierLabel, BOX_STATUS, boxStatusBadge } from "./pei";

const ItemStatus = {
    PACKED: 2,
    SENT: 3,
    RECEIVED: 4,
    REJECTED: 5,
    CANCELLED: 6
};

const PHOTO_TYPES = ["image/jpeg", "image/png"];
const VIDEO_TYPES = ["video/mp4", "video/quicktime"];
const MAX_PHOTO_SIZE = 10 * 1024 * 1024; // 10MB
const MAX_VIDEO_SIZE = 400 * 1024 * 1024; // 400MB

export default {
    components: {
        LoadingOverlay
    },

    props: {
        shipmentId: { type: [Number, String], required: true }
    },

    data() {
        return {
            BoxStatus: BOX_STATUS,
            courierOptions: COURIER_OPTIONS,
            isSubmitting: false,
            isBusy: true,

            data: {},
            items: [],

            input: {
                courier: null,
                no_resi: ""
            },
            photo: { path: null, previewUrl: null },
            video: { path: null, previewUrl: null },

            uploadTimeStamp: {
                startPresignedUrl: null,
                endPresignedUrl: null,
                startUploadToS3: null,
                endUploadToS3: null,
                startSaveFile: null,
                endSaveFile: null
            },
            isShowLoadingOverlay: false,
            mediaDirPath: "pei-shipments",

            fields: [
                { key: "no_faktur", label: "No. Faktur", sortable: false },
                {
                    key: "status",
                    label: "Status",
                    thClass: "text-center",
                    tdClass: "text-center",
                    sortable: false
                },
                { key: "kind", label: "Jenis Item", sortable: false },
                { key: "brand", label: "Merk Item", sortable: false },
                { key: "type", label: "Jenis Emas", sortable: false },
                { key: "source", label: "Source", sortable: false, formatter: v => v || "-" },
                { key: "purity", label: "Kadar", sortable: false },
                { key: "dry_weight", label: "Berat Kotor", sortable: false },
                {
                    key: "weight_reduction",
                    label: "Berat Potongan",
                    sortable: false
                },
                { key: "action", label: "Aksi", sortable: false }
            ],

            options: [
                { value: 10, text: "10" },
                { value: 20, text: "20" },
                { value: 30, text: "30" },
                { value: 40, text: "40" },
                { value: 50, text: "50" }
            ],

            currentPage: 1,
            perPage: 10,

            totalRows: 0,
            invoiceLink: "",
            invoiceLinkA4: "",
            qrLink: "",
            invoiceSize: "A5",
            invoiceSizeCooldown: false
        };
    },

    computed: {
        isPickup() {
            return this.input.courier === PICKUP;
        }
    },

    methods: {
        courierLabel,

        getItems(page) {
            this.isBusy = true;

            if (isNaN(page)) {
                this.currentPage = 1;
            } else {
                this.currentPage = page;
            }

            let param = this.$helper.getBasePagedQuery(
                this.currentPage,
                this.perPage
            );

            return this.$axios
                .get("/pei-shipment/" + this.shipmentId + param)
                .then(res => {
                    this.items = res.data.data.items;
                    this.data = res.data.data;
                    this.totalRows = res.data.data.total;
                    this.invoiceLink = res.data.data.link;
                    this.invoiceLinkA4 = res.data.data.linka4;
                    this.qrLink = res.data.data.qr_link;
                })
                .catch(error => this.$helper.parseError(this, error))
                .finally(() => {
                    this.isBusy = false;
                });
        },

        confirmSendShipment() {
            this.input.courier = null;
            this.input.no_resi = "";
            this.clearMedia("photo");
            this.clearMedia("video");
            this.$bvModal.show("m-confirm-send-shipment");
        },

        executeSendShipment() {
            if (this.$helper.isBlank(this.input.courier)) {
                return this.$helper.toastError(this, "Kurir harus dipilih!");
            }
            if (!this.isPickup && this.$helper.isBlank(this.input.no_resi)) {
                return this.$helper.toastError(this, "Nomor resi harus diisi!");
            }
            if (!this.photo.path || !this.video.path) {
                return this.$helper.toastError(
                    this,
                    "Upload foto dan video packing terlebih dahulu!"
                );
            }

            if (
                !confirm(
                    "Apakah Anda yakin ingin mengirim stock PEI dengan data ini?"
                )
            ) {
                return;
            }

            this.isSubmitting = true;

            let payload = {
                courier: this.input.courier,
                no_resi: this.isPickup ? null : this.input.no_resi,
                photo_packing: this.photo.path,
                video_packing: this.video.path
            };

            this.$axios
                .post(`/pei-shipment/${this.shipmentId}/send`, payload)
                .then(res => {
                    this.$helper.toastSuccess(
                        this,
                        `Pengiriman berhasil dikirim`
                    );
                    this.invoiceLink = res.data.data.link;
                    this.invoiceLinkA4 = res.data.data.linka4;

                    this.$bvModal.hide("m-confirm-send-shipment");
                    this.$bvModal.show("m-print-invoice");
                    this.getItems(this.currentPage);
                    this.$emit("changed", { deleted: false });
                })
                .catch(error => this.$helper.parseError(this, error))
                .finally(() => {
                    this.isSubmitting = false;
                });
        },

        async getPresignedUrl(fileName, fileType) {
            this.uploadTimeStamp.startPresignedUrl = this.formatTime(
                new Date()
            );
            const payload = {
                file_name: fileName,
                file_type: fileType,
                reference_key: this.data.no_box,
                directory_path: this.mediaDirPath
            };
            const response = await this.$axios.post(
                "get-presigned-url",
                payload
            );
            this.uploadTimeStamp.endPresignedUrl = this.formatTime(new Date());
            return response.data.data;
        },

        async uploadToS3(file, presignedUrl) {
            this.uploadTimeStamp.startUploadToS3 = this.formatTime(new Date());
            const response = await fetch(presignedUrl, {
                method: "PUT",
                body: file,
                headers: {
                    "Content-Type": file.type
                }
            });
            if (!response.ok) throw new Error("Upload to S3 failed");
            this.uploadTimeStamp.endUploadToS3 = this.formatTime(new Date());
            return response;
        },

        // slot: "photo" | "video"
        async onMediaPicked(slot, file) {
            if (!file) return;

            const isPhoto = slot === "photo";
            const types = isPhoto ? PHOTO_TYPES : VIDEO_TYPES;
            const maxSize = isPhoto ? MAX_PHOTO_SIZE : MAX_VIDEO_SIZE;
            if (!types.includes(file.type)) {
                return this.$helper.toastError(
                    this,
                    `File ${file.name} tidak sesuai dengan tipe file yang diizinkan`
                );
            }
            if (file.size > maxSize) {
                return this.$helper.toastError(
                    this,
                    `File ${file.name} melebihi ${isPhoto ? "10MB" : "400MB"}.`
                );
            }

            this.isShowLoadingOverlay = true;
            try {
                const { presigned_url, file_path } = await this.getPresignedUrl(
                    file.name,
                    file.type
                );

                await this.uploadToS3(file, presigned_url);

                this.uploadTimeStamp.startSaveFile = this.formatTime(new Date());
                this.uploadTimeStamp.endSaveFile = this.formatTime(new Date());

                this.clearMedia(slot);
                this[slot] = {
                    path: `${this.mediaDirPath}/${this.data.no_box}/${file_path}`,
                    previewUrl: URL.createObjectURL(file)
                };

                this.$helper.toastSuccess(
                    this,
                    isPhoto ? "Foto berhasil diupload" : "Video berhasil diupload"
                );
            } catch (error) {
                this.$helper.parseError(this, error);
            }
            this.isShowLoadingOverlay = false;
            this.resetUploadTimestamp();
        },

        // slot: "photo" | "video"
        clearMedia(slot) {
            if (this[slot].previewUrl) {
                URL.revokeObjectURL(this[slot].previewUrl);
            }
            this[slot] = { path: null, previewUrl: null };
        },

        confirmCancelItem(item) {
            if (!confirm(`Keluarkan barang ${item.no_faktur} dari box ini?`)) {
                return;
            }

            this.$axios
                .post(`/pei-shipment/${this.shipmentId}/cancel-item`, {
                    pei_shipment_item_id: item.id
                })
                .then(res => {
                    this.$helper.toastSuccess(
                        this,
                        "Barang dikeluarkan dari box"
                    );
                    const deleted = !!res.data.data.box_deleted;
                    if (!deleted) this.getItems(this.currentPage);
                    this.$emit("changed", { deleted });
                })
                .catch(error => this.$helper.parseError(this, error));
        },

        confirmDeleteBox() {
            if (
                !confirm(
                    "Hapus box ini? Semua barang akan dikeluarkan dari box."
                )
            ) {
                return;
            }

            this.$axios
                .delete(`/pei-shipment/${this.shipmentId}`)
                .then(() => {
                    this.$helper.toastSuccess(this, "Box berhasil dihapus");
                    this.$emit("changed", { deleted: true });
                })
                .catch(error => this.$helper.parseError(this, error));
        },

        getInvoiceLink() {
            if (this.invoiceSize == "A5") {
                return this.invoiceLink;
            } else {
                return this.invoiceLinkA4;
            }
        },

        toggleInvoiceSize() {
            this.invoiceSizeCooldown = true;
            if (this.invoiceSize == "A5") this.invoiceSize = "A4";
            else this.invoiceSize = "A5";
            setTimeout(
                function() {
                    this.invoiceSizeCooldown = false;
                }.bind(this),
                2000
            );
        },

        resetUploadTimestamp() {
            this.uploadTimeStamp = {
                startPresignedUrl: null,
                endPresignedUrl: null,
                startUploadToS3: null,
                endUploadToS3: null,
                startSaveFile: null,
                endSaveFile: null
            };
        },

        formatTime(date) {
            const hh = String(date.getHours()).padStart(2, "0");
            const mm = String(date.getMinutes()).padStart(2, "0");
            const ss = String(date.getSeconds()).padStart(2, "0");
            return `${hh}:${mm}:${ss}`;
        },

        onLimitChange(newPerPage) {
            this.perPage = newPerPage;
            this.getItems(this.currentPage);
        },

        onPageChange(newPage) {
            this.currentPage = newPage;
            this.getItems(this.currentPage);
        },

        // NF status in this box.
        getItemStatusBadge(status) {
            switch (status) {
                case ItemStatus.PACKED:
                    return ["secondary", "DIKEMAS"];
                case ItemStatus.SENT:
                    return ["info", "DIKIRIM"];
                case ItemStatus.RECEIVED:
                    return ["success", "DITERIMA"];
                case ItemStatus.REJECTED:
                    return ["danger", "DITOLAK"];
                case ItemStatus.CANCELLED:
                    return ["danger", "DIBATALKAN"];
                default:
                    return ["light", "-"];
            }
        },

        getBoxStatusBadge: boxStatusBadge
    },

    created() {
        this.getItems();
    },

    beforeDestroy() {
        this.clearMedia("photo");
        this.clearMedia("video");
    }
};
</script>

<style scoped>
.info-grid {
    display: grid;
    grid-template-columns: auto 1fr;
    gap: 8px 16px;
    align-items: baseline;
}

.info-grid dt {
    color: #6c757d;
    font-weight: 500;
    white-space: nowrap;
    margin: 0;
}

.info-grid dd {
    margin: 0;
    font-weight: 600;
}

.field-label {
    font-size: 12px;
    text-transform: uppercase;
    letter-spacing: 0.4px;
    color: #8a94a6;
    margin-bottom: 6px;
}

.photo-thumb-wrap {
    display: inline-block;
    width: 96px;
    height: 96px;
}

.photo-thumb-wrap img {
    width: 96px;
    height: 96px;
    object-fit: cover;
    border-radius: 8px;
    border: 1px solid #e9ecef;
    transition: all 0.2s ease-in-out;
    cursor: pointer;
}

.photo-thumb-wrap:hover img {
    transform: scale(1.05);
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
    border-color: #adb5bd;
}

.video-thumb-wrap {
    position: relative;
    display: inline-block;
    width: 96px;
    height: 96px;
}

.video-thumb-wrap video {
    width: 96px;
    height: 96px;
    object-fit: cover;
    border-radius: 8px;
    border: 1px solid #e9ecef;
    transition: all 0.2s ease-in-out;
    cursor: pointer;
}

.video-thumb-wrap:hover video {
    transform: scale(1.05);
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
    border-color: #adb5bd;
}

.play-badge {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
    width: 34px;
    height: 34px;
    color: #fff;
    background: rgba(0, 0, 0, 0.55);
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    pointer-events: none;
}
</style>
